import React from "react";
import Spacing from "../Spacing";
import SectionHeadingStyle6 from "../SectionHeading/SectionHeadingStyle6";
// import { Icon } from "@iconify/react";
// import AuthorWidget from "../Widget/AuthorWidget";
import { pageTitle } from "../../helpers/PageTitle";
import { Link, useParams } from "react-router-dom";
import { blogData } from "../../data/blogs";

export default function BlogDetailsPage() {
  pageTitle("Blog Details");
  const { blogDetailsId } = useParams();
  console.log(blogDetailsId);

  const blog = blogData.find((blog) => blog.slug === blogDetailsId);

  const getFormattedDate = (date) => {
    const d = new Date(date);
    const month = d.toLocaleString("default", { month: "long" });
    const day = d.getDate();
    const year = d.getFullYear();
    return `${day} ${month} ${year}`;
  };

  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />

      <div >
        <div className="col-lg-5" style={{ marginLeft: "161px", marginTop: "50px" }}>
          <Link to="/blog-list">
            <a href="/" className="cs_down_btn cs_center cs_primary_color">
              <svg
                style={{ transform: 'rotate(90deg)' }}
                width={8}
                height={33}
                viewBox="0 0 8 33"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.64645 32.3536C3.84171 32.5488 4.15829 32.5488 4.35355 32.3536L7.53554 29.1716C7.7308 28.9763 7.7308 28.6597 7.53554 28.4645C7.34027 28.2692 7.02369 28.2692 6.82843 28.4645L4 31.2929L1.17157 28.4645C0.976312 28.2692 0.65973 28.2692 0.464467 28.4645C0.269205 28.6597 0.269205 28.9763 0.464467 29.1716L3.64645 32.3536ZM3.5 2.18557e-08L3.5 32L4.5 32L4.5 -2.18557e-08L3.5 2.18557e-08Z"
                  fill="currentColor"
                />
              </svg>
            </a>
          </Link>
        </div>
        <SectionHeadingStyle6
          title={blog ? blog.title : "Not found!"}
          title2={blog ? blog.title2 : "Not found!"}
          variant="text-center"
          shape="shape_5"
          date={getFormattedDate(blog.date)}
          avatar="Keyword"
          avatarLink="/"
        />
      </div>
      <Spacing lg="75" md="60" />
      <div
        className="container"
        style={{
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <img src={blog.thumbnailSrc} alt="Blog" className="cs_radius_15" />
        <div className="cs_height_60 cs_height_lg_40" />
        <div className="cs_post_details">
          {blog.content.map((item, index) => {
            return (
              <>
                <div style={{ textAlign: "right" }}>
                  <div key={index}>
                    <h3>{item.header}</h3>
                    {item.paragraph.map((para, index) => (
                      <p key={index}>{para}</p>
                    ))}
                    <div className="cs_height_30 cs_height_lg_20" />
                  </div>
                  <div key={index}>
                    <h3>{item.header2}</h3>
                    {item.paragraph2.map((para, index) => (
                      <p key={index}>{para}</p>
                    ))}
                    <div className="cs_height_30 cs_height_lg_20" />
                  </div>
                </div>
              </>

            );
          })}
          <div className="cs_height_150 cs_height_lg_80" />
        </div>
      </div>
    </>
  );
}
